module.exports = {
      id: "aries-usage",
      viewBox: "0 0 48 48",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#aries",
      toString: function () {
        return this.url;
      }
    }